import { render, staticRenderFns } from "./CostImporterTransactionMatchingStaff.vue?vue&type=template&id=27c0e9a2&scoped=true&"
import script from "./CostImporterTransactionMatchingStaff.vue?vue&type=script&lang=js&"
export * from "./CostImporterTransactionMatchingStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0e9a2",
  null
  
)

export default component.exports